const info = '受理公民、法人和其他组织对青海省政府采购相关工作的意见、建议、求助、批评、咨询等，相关责任单位交办和转办群众反映的问题，督促检查办理的情况，反馈处理结果。';
class qingHaiMail {
  constructor () {
    this.imgTitle = $('.img-info');
    this.init();
  }
  init () {
    let here = this;
    here.imgTitle.html(info);
  }
}


module.exports = qingHaiMail;
